import { ArrayList3it5z8td81qkl as ArrayList } from './ArrayListJs.mjs';
import { addAll1k27qatfgp3k5 as addAll } from './MutableCollections.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import {
  Collection1k04j3hzsbod0 as Collection,
  Iterable1y3qizuf89iou as Iterable,
} from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { IndexingIterator2403qllmopoxd as IndexingIterator } from './Iterators.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function flatten(_this__u8e3s4) {
  var result = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    addAll(result, element);
  }
  return result;
}
function collectionSizeOrDefault(_this__u8e3s4, default_0) {
  var tmp;
  if (isInterface(_this__u8e3s4, Collection())) {
    tmp = _this__u8e3s4.get_size_woubt6_k$();
  } else {
    tmp = default_0;
  }
  return tmp;
}
var IndexingIterableClass;
function IndexingIterable() {
  if (IndexingIterableClass === VOID) {
    class $ {
      constructor(iteratorFactory) {
        this.iteratorFactory_1 = iteratorFactory;
      }
      iterator_jk1svi_k$() {
        return new (IndexingIterator())(this.iteratorFactory_1());
      }
    }
    initMetadataForClass($, 'IndexingIterable', VOID, VOID, [Iterable()]);
    IndexingIterableClass = $;
  }
  return IndexingIterableClass;
}
function collectionSizeOrNull(_this__u8e3s4) {
  var tmp;
  if (isInterface(_this__u8e3s4, Collection())) {
    tmp = _this__u8e3s4.get_size_woubt6_k$();
  } else {
    tmp = null;
  }
  return tmp;
}
//region block: exports
export {
  IndexingIterable as IndexingIterable2a6g9uso7i6wu,
  collectionSizeOrDefault as collectionSizeOrDefault36dulx8yinfqm,
  collectionSizeOrNull as collectionSizeOrNull1v5nsm81on7r9,
  flatten as flatten2dh4kibw1u0qq,
};
//endregion

//# sourceMappingURL=Iterables.mjs.map
